import * as com from "../../Common.js";
import { getCustomerId, getLoId } from "../../Common";
import { useSelector, useDispatch } from "react-redux";
import * as subscriptions from "../../Store/subscriptions";
import { IS_WHITE_LIST, getIframesToken, IS_IFRAMES } from "../constants";
import { getClientToken } from "utils.js";
import { request } from "../../request";

// Scenario AI 非付费用户，最大使用限制
// 本次需求 最多使用三次
const MAX_COUNT = 3;

/**
 * @name useScenarioUsed "Scenario AI" 使用限制
 */
export default function useScenarioUsed() {
  const dispatch = useDispatch();

  const STORE =
    useSelector((s: any) => s.subscriptionReducer?.currentInfo) || {};

  // const COUNT = STORE?.usage?.scenarioDeskUsage; // Scenario AI 次数
  // 获取使用次数：登录用户从Redux store读取，未登录用户从localStorage读取
  const COUNT = (() => {
    const isLoggedIn = !!sessionStorage.getItem("ZeitroA") || !!localStorage.getItem(getIframesToken());
    const scenarioDeskUsage = STORE?.usage?.scenarioDeskUsage || 0;
    const guidelineGptUsage = STORE?.usage?.guidelineGptUsage || 0;
    if (isLoggedIn) {
      // In iframe mode, combine guideline and scenario desk usage
      if (IS_IFRAMES) {
        return scenarioDeskUsage + guidelineGptUsage;
      }
      
      return scenarioDeskUsage;
    } else {
      // 未登录用户从localStorage读取
      // const localScenarioCount = localStorage.getItem("scenarioDesk");
      const scenarioCount = scenarioDeskUsage ? parseInt(scenarioDeskUsage, 10) : 0;
      
      // In iframe mode, also read guideline usage from localStorage
      if (IS_IFRAMES) {
        // const localGuidelineCount = localStorage.getItem("guideline");
        const guidelineCount = guidelineGptUsage ? parseInt(guidelineGptUsage, 10) : 0;
        return scenarioCount + guidelineCount;
      }
      
      return scenarioCount;
    }
  })();

  // 根据客户ID确定是否设置限制
  const shouldApplyLimit = !IS_WHITE_LIST;

  // 更新用户使用 Scenario AI 次数
  async function onUpdateScenarioUsed() {
    // 如果未登陆，使用客户端ID 记录
    if(!sessionStorage.getItem("ZeitroA")){
      const clientId = await getClientToken();
      request(`/api/v1/limit/scenarioDesk/${clientId}`,{ method: 'PUT' });
    }
    dispatch(subscriptions.updateScenarioDeskUsage(COUNT + 1));
  }

  // const FREE_STATUS = com.getFreeStatus(STORE?.plan, STORE.loanOfficers);

  // 判断是否登录
  const isLoggedIn = !!sessionStorage.getItem("ZeitroA") || !!localStorage.getItem(getIframesToken());
  
  // 未登录用户视为免费用户
  const FREE_STATUS = isLoggedIn 
    ? com.getFreeStatus(STORE?.plan, STORE.loanOfficers)
    : true;

  const REMAINING_COUNT = MAX_COUNT - COUNT; // 剩余可用次数

  return {
    /**
     * @param DISABLED 是否超过限制
     * @description 付费不限次数，普通用户超过限制、则禁止使用
     */
    DISABLED: shouldApplyLimit && COUNT > MAX_COUNT - 1,
    /**
     * @param COUNT 已使用次数
     */
    COUNT,
    /**
     * @param REMAINING 剩余可次数
     */
    REMAINING: REMAINING_COUNT > 0 ? REMAINING_COUNT : 0,
    /**
     * @param PAID 是否为付费用户
     */
    PAID: !FREE_STATUS,
    /**
     * @name onUsed 触发一次 "Scenario AI" 使用次数更新
     * @description 用户行为埋点
     */
    onUsed: onUpdateScenarioUsed,
  };
}
